import { render, staticRenderFns } from "./NewCampaignMail.vue?vue&type=template&id=2667dfa3&scoped=true&"
import script from "./NewCampaignMail.vue?vue&type=script&lang=js&"
export * from "./NewCampaignMail.vue?vue&type=script&lang=js&"
import style0 from "./NewCampaignMail.vue?vue&type=style&index=0&id=2667dfa3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2667dfa3",
  null
  
)

export default component.exports